<template>
	<div v-show="showModal">
		<section class="popup">
			<article class="popHead">
                <p class="title"><slot name="info"></slot></p>
			</article>
			<article class="popCont">
				<div class="inner">
					<slot name="content"></slot>
				</div>
			</article>
			<article>
				<slot name="button"></slot>
			</article>
		</section>
		<section class="dim">
			<slot name="dimarea"></slot>
		</section>
	</div>
</template>

<script>

export default {
	data(){
		return{
			showModal : true
		}
	},

}
</script>

<style scoped>

</style> 